import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import InfiniteSiteCopyTable from './Table';
import NewSiteCopyModal from '../../Modals/SiteCopy/NewSiteCopyModal';
import AdminPageHead from '../../Common/PageHead';
import style from './styles/style.module.css';

class AllSiteCopyView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            copyList: [],
        };
    }
    componentDidMount() {
        this.loadCopy();
    }
    loadCopy = () => {
        return this.props.getCopy()
        .then( ( copyList ) => {
            this.setState( ( prevState ) => {
                prevState.fetching= false;
                prevState.copyList = prevState.copyList.concat( copyList );
                return prevState;
            } );
            return copyList;
        } );
    }
    siteCopyUpdated = ( index, newCopy ) => {
        this.setState( ( altState ) => {
            if( newCopy !== null ) {
                altState.copyList[ index ] = newCopy;
                altState.copyList = altState.copyList.slice( 0 );
            } else {
                altState.copyList = altState.copyList.slice( 0, index ).concat( altState.copyList.slice( index +1 ) );
            }
            return altState;
        } );
    }

    openNewModal = () => {
        this.setState( { newModal: true } );
    }
    onNewModalClose = () => {
        this.setState( { newModal: false } );
    }
    onNewModalSubmit = ( newSiteCopy ) => {
        this.setState( ( altState ) => {
            altState.copyList.unshift( newSiteCopy );
            altState.copyList = altState.copyList.slice( 0 );
            altState.newModal = false;
            return altState;
        } );
    }


    render() {
        const { fetching, copyList } = this.state;

        return (
            <section className={ style.page }>
                <AdminPageHead title='Site Copy'
                tabs={ [
                    { label: 'View All', to: '/admin/site-copy' },
                ] }
                buttons={ [
                    { label: '+ Add New Copy', onClick: this.openNewModal },
                ] } />
                <div className={ style.body }>
                    <section className={ style.allList }>
                        <div className={ style.filters }>
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <InfiniteSiteCopyTable
                            copyList={ copyList }
                            onSiteCopyUpdated={ this.siteCopyUpdated }/>
                        }
                    </section>
                </div>
                { this.state.newModal &&
                    <NewSiteCopyModal closeModal={ this.onNewModalClose }
                    onSubmit={ this.onNewModalSubmit }/>
                }
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getCopy: () => {
            return dAPI.get( '/dynamicCopy', { limit: 9999 } );

        },
    };
};

export default connect( null, mapDispatchToProps )( AllSiteCopyView );
